import type { AdminUser } from "@features/users/api";
import type { OnboardingStep } from "../types";

export const LS_TELEGRAM_TOUR_DONE = "acweb_telegram_tour_completed";
export const LS_SUPPORT_TOUR_DONE = "acweb_support_tour_completed";
export const LS_ONBOARDING_DONE = "acweb_onboarding_completed";

export function useOnboardingState(user: AdminUser | null | undefined): OnboardingStep {
  if (!user) return "done";

  const hasPhone = user.contacts?.some(
    (c) => c.type === "phone" && c.value && c.value.trim() !== "",
  );
  const hasTelegram = !!user.telegram_id;
  const telegramTourDone = localStorage.getItem(LS_TELEGRAM_TOUR_DONE);
  const supportTourDone = localStorage.getItem(LS_SUPPORT_TOUR_DONE);
  const tourCompleted = localStorage.getItem(LS_ONBOARDING_DONE);

  if (!hasPhone) return "phone";
  if (!hasTelegram && !telegramTourDone) return "telegram-tour";
  if (!supportTourDone) return "support-tour";
  if (!tourCompleted) return "interface-tour";
  return "done";
}
